import OrganizationItem from './OrganizationItem';

export default OrganizationItem;
